export const SurveyTrigger_ActionPlanArchive = 'actionPlanArchive';
export const SurveyTrigger_AssessmentClose = 'assessmentClose';
